import { AttributeWrite } from './attributeWrite';

export class ComplexAttributeWrite {
  public attributeDefinitionId: string;
  public complexSubFieldValues: ComplexSubFieldValuesWrite[];
}

export class ComplexSubFieldValuesWrite {
  public subFieldDefinitionItemId: string;
  public subFieldItemValue: AttributeWrite;
}
